import React from 'react'
import { useQuery } from '@tanstack/react-query'
import { RadioButton } from '../../../common/RadioButton'
import { IUnitModel } from '../../../../interfaces/models/units.interfaces'
import { entranceQueries } from '../../../../api/society-entrances'

export interface FacilityCalendarUnitSelect {
  selectedUnitId: string | undefined
  setSelectedUnitId: (unitId: string | undefined) => void
  userUnits: IUnitModel[]
}

export const FacilityCalendarUnitSelect = ({
  selectedUnitId,
  setSelectedUnitId,
  userUnits,
}: FacilityCalendarUnitSelect): React.ReactNode => {
  const { data: societyEntrances } = useQuery(
    entranceQueries.getEntrancesPerSociety(userUnits[0].societyId)
  )
  return (
    <div className="flex flex-col gap-2">
      {userUnits.map((_unit) => {
        const entrance =
          _unit.entranceId &&
          societyEntrances?.find(
            (_entrance) => _entrance._id === _unit.entranceId
          )
        return (
          <RadioButton
            key={_unit._id}
            name={_unit._id}
            value={_unit._id}
            checked={_unit._id === selectedUnitId}
            label={`${[
              entrance && entrance.addressStreet,
              _unit.title
                ? `${_unit.titleLegal} (${_unit.title})`
                : _unit.titleLegal,
            ].join(', ')}`}
            onChange={() => setSelectedUnitId(_unit._id)}
          />
        )
      })}
    </div>
  )
}
